const SCRIPT_ID = "n9-google-identity-script";
let pending;
let initializedClientId = "";
let activeHandler = null;

export function loadGoogleIdentity(timeoutMs = 12_000) {
  if (window.google?.accounts?.id) return Promise.resolve(window.google);
  if (pending) return pending;
  pending = new Promise((resolve, reject) => {
    let script = document.getElementById(SCRIPT_ID);
    const existing = Boolean(script);
    script ||= document.createElement("script");
    const cleanup = () => {
      clearTimeout(timer);
      script.removeEventListener("load", loaded);
      script.removeEventListener("error", failed);
    };
    const failed = () => {
      cleanup();
      script.remove();
      reject(new Error("GOOGLE_LOAD_FAILED"));
    };
    const loaded = () => {
      if (!window.google?.accounts?.id) return failed();
      cleanup();
      resolve(window.google);
    };
    const timer = setTimeout(failed, timeoutMs);
    script.addEventListener("load", loaded, { once: true });
    script.addEventListener("error", failed, { once: true });
    if (!existing) {
      script.id = SCRIPT_ID;
      script.src = "https://accounts.google.com/gsi/client";
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  }).catch((error) => {
    pending = undefined;
    throw error;
  });
  return pending;
}

export function attachGoogleHandler(google, clientId, handler) {
  activeHandler = handler;
  if (initializedClientId !== clientId) {
    google.accounts.id.initialize({
      client_id: clientId,
      callback: ({ credential }) => activeHandler?.(credential),
      auto_select: false,
      cancel_on_tap_outside: true,
    });
    initializedClientId = clientId;
  }
  return () => { if (activeHandler === handler) activeHandler = null; };
}
